import { Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertDialog } from "./dialog/AlertDialog";

export const CancelButton = () => {
  const navigate = useNavigate();
  const [isTapped, setIsTapped] = useState(false);
  const onClickBackBtn = () => {
    navigate(-1);
  };
  const onCancelBtm = () => {
    setIsTapped(false);
  }

  return (
    <><Button
      variant="contained"
      color="error"
      onClick={() => setIsTapped(true)}
    >
      キャンセル
    </Button>
    <AlertDialog
      isAlertDialogOpen={isTapped}
      title="確認"
      message="処理を中断しますか？"
      mode="中断"
      handleAlertCancel={() => onCancelBtm()}
      handleAlertOk={() => onClickBackBtn()}
    /></>
  );
};